// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBox h1 {
  margin-bottom: 20px;
}
@media screen and (max-width: 1440px) {
  .topBox h1 {
    font-size: 24px;
  }
}
.topBox .list .listItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.topBox .list .listItem .user {
  display: flex;
  gap: 20px;
}
.topBox .list .listItem .user img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
@media screen and (max-width: 1440px) {
  .topBox .list .listItem .user img {
    display: none;
  }
}
@media screen and (max-width: 1024px) {
  .topBox .list .listItem .user img {
    display: block;
  }
}
.topBox .list .listItem .user .userTexts {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.topBox .list .listItem .user .userTexts .userName {
  font-size: 14px;
  font-weight: 500;
}
.topBox .list .listItem .user .userTexts .email {
  font-size: 12px;
}
@media screen and (max-width: 1440px) {
  .topBox .list .listItem .user .userTexts .email {
    display: none;
  }
}
@media screen and (max-width: 1024px) {
  .topBox .list .listItem .user .userTexts .email {
    display: block;
  }
}
.topBox .list .listItem .amount {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/topBox/topBox.scss","webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAEE;EACE,mBAAA;AADJ;AC6BE;ED7BA;IAII,eAAA;EAAJ;AACF;AAII;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAFN;AAIM;EACE,aAAA;EACA,SAAA;AAFR;AAGQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADV;ACQE;EDXM;IAOI,aAAA;EAAV;AACF;ACTE;EDCM;IAUI,cAAA;EAEV;AACF;AAAQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAEV;AAAU;EACE,eAAA;EACA,gBAAA;AAEZ;AAAU;EACE,eAAA;AAEZ;ACdE;EDWQ;IAII,aAAA;EAGZ;AACF;AC/BE;EDuBQ;IAQI,cAAA;EAIZ;AACF;AAAM;EACE,gBAAA;AAER","sourcesContent":["@import \"../../styles/responsive.scss\";\n.topBox {\n  h1 {\n    margin-bottom: 20px;\n\n    @include xxl {\n      font-size: 24px;\n    }\n  }\n\n  .list {\n    .listItem {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 30px;\n\n      .user {\n        display: flex;\n        gap: 20px;\n        img {\n          width: 40px;\n          height: 40px;\n          border-radius: 50%;\n          object-fit: cover;\n\n          @include xxl {\n            display: none;\n          }\n          @include lg {\n            display: block;\n          }\n        }\n        .userTexts {\n          display: flex;\n          flex-direction: column;\n          gap: 5px;\n\n          .userName {\n            font-size: 14px;\n            font-weight: 500;\n          }\n          .email {\n            font-size: 12px;\n\n            @include xxl {\n              display: none;\n            }\n\n            @include lg {\n              display: block;\n            }\n          }\n        }\n      }\n      .amount {\n        font-weight: 500;\n      }\n    }\n  }\n}\n","$sm: 480px;\n$md: 768px;\n$lg: 1024px;\n$xl: 1200px;\n$xxl: 1440px;\n\n@mixin sm {\n  @media screen and (max-width: $sm) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media screen and (max-width: $md) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media screen and (max-width: $lg) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media screen and (max-width: $xl) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media screen and (max-width: $xxl) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
